//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start

import { memo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { BzButton, BzChip, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { getAlerts, removeMultipleAlerts } from "../../redux/actions/alerts";
import { handleModal } from "../../redux/actions/modals";
import { toastConfig } from "../../redux/actions/toast";
import AlertNameDetails from "./AlertNameDetails";
import config from "../../config.json";
import { SET_ALERT_FIELDS } from "../../utils/global_variables";
import { getMappedMktSegIdFromApiExchangeName } from "../../utils/global_functions";

const DeleteAlertConfirmModal = ({ arrSelectedDeleteAlert, setArrSelectedDeleteAlert }) => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    const handleHide = () => {

        dispatch(handleModal([{ "DELETE_ALERT_CONFIRM_MODAL": false }]));

    };

    const handleRemoveAlert = () => {
        //Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - Start
        // if (bINesperAlert) {
        const arrPayload = arrSelectedDeleteAlert?.map((alert) => {
            return ({
                "condition": [
                    {
                        "operand1": {
                            "marketsegment": getMappedMktSegIdFromApiExchangeName(alert.scripObj.ExchangeSegment),
                            "token": alert.nToken,
                            "field": alert.factor1
                        },
                        "operand2": {
                            "marketsegment": getMappedMktSegIdFromApiExchangeName(alert.scripObj.ExchangeSegment),
                            "token": alert.nToken,
                            "field": alert.factor2,
                            "value": alert.amount
                        },
                        "operator": alert.operator
                    }
                ],
                "data": {
                    "remarks": "",
                    "userid": objLoginSession?.data?.user_id,
                    "tenantid": config.TenantId,
                    "symbol": alert.symbol,
                    "alertType": alert.alertType,
                    "category": alert.category
                },
                "expiration": alert.expiration,
                "createDate": alert.createDate,
                "tenantId": config.TenantId,
                "workerId": alert.workerId,
                "triggered": alert.triggered,
                "entryTime": alert.entryTime,
                "UCC": objLoginSession?.data?.user_id,
                "MessageType": "USR_ALERT",
                "serverAlertId": alert.serverAlertId,
                "UniqueId": alert.UniqueId,
                "time": Date.now(),//new Date(alert.createDate).getTime(),
                "triggeredDate": "",
                "token": alert.nToken,
                "mktSegId": getMappedMktSegIdFromApiExchangeName(alert.scripObj.ExchangeSegment),
                "exchange": alert.scripObj.ExchangeSegment,
                "displayExchange": alert.exchange,
                "price": alert.amount,
                "alert": SET_ALERT_FIELDS.FACTOR1[alert.factor1]?.value,
                "pricealert": SET_ALERT_FIELDS.FACTOR2[alert.factor2]?.value === 'USE_VALUE' ? alert.amount : SET_ALERT_FIELDS.FACTOR2[alert.factor2]?.value,
                "comparator": alert.operator,
                "scripObj": alert.scripObj,
                "Series": alert.series,
                "displayScripDesc": ""
            });
        });

        dispatch(removeMultipleAlerts({ data: arrPayload })).then((objResp) => {
            if (objResp?.data.status === "success") {
                dispatch(handleModal([{ "DELETE_ALERT_CONFIRM_MODAL": false }, { "DELETE_ALERT_SUCCESS_MODAL": true }]));
                setArrSelectedDeleteAlert([]);
                setTimeout(() => {
                    dispatch(getAlerts(objLoginSession?.data?.user_id));
                }, 3000);
                dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove Selected Alerts <div className='notification-count font-regular ms-2'>0</div></div>, button: [{ btnName: "Close", type: "CLOSE_REMOVE_ALERT_TOASTER", className: "btn btn-outline-active ms-3" }, { btnName: "Remove Alert", type: "REMOVE_ALERT", className: "btn btn-outline-active ms-3", bIsDisabled: true }] }));

            } else {
                dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Alert(s) has been not deleted.', }));
                setTimeout(() => {
                    dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove Selected Alerts <div className='notification-count font-regular ms-2'>0</div></div>, button: [{ btnName: "Close", type: "CLOSE_REMOVE_ALERT_TOASTER", className: "btn btn-outline-active ms-3" }, { btnName: "Remove Alert", type: "REMOVE_ALERT", className: "btn btn-outline-active ms-3", bIsDisabled: true }] }));
                }, 3000);
            }
        });
        // Azeem K :20-03-2025 :  as per discussion with Norwin and Indresh Delete api is not using right now, for nesper and redis alert using deleteScripAlert post api so delete api code commented, code will remove later --Start
        // } else {
        //     arrSelectedDeleteAlert?.forEach((item) => {
        //         dispatch(removeAlert({ userID: objLoginSession?.data?.user_id, serverAlertId: item?.serverAlertId }));
        //     });
        //     dispatch(handleModal([{ "DELETE_ALERT_CONFIRM_MODAL": false }, { "DELETE_ALERT_SUCCESS_MODAL": true }]));
        //     setArrSelectedDeleteAlert([]);
        //     setTimeout(() => {
        //         dispatch(getAlerts(objLoginSession?.data?.user_id));
        //     }, 3000);
        //     dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove Selected Alerts <div className='notification-count font-regular ms-2'>0</div></div>, button: [{ btnName: "Close", type: "CLOSE_REMOVE_ALERT_TOASTER", className: "btn btn-outline-active ms-3" }, { btnName: "Remove Alert", type: "REMOVE_ALERT", className: "btn btn-outline-active ms-3", bIsDisabled: true }] }));
        // }
        // Azeem K :20-03-2025 :  as per discussion with Norwin and Indresh Delete api is not using right now, for nesper and redis alert using deleteScripAlert post api so delete api code commented, code will remove later --End

        //Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - End

    };

    return (
        <>
            <BzModal size="md" show={modals['DELETE_ALERT_CONFIRM_MODAL']} onHide={handleHide}>
                <BzModalHeader className='modaltabs-header modal-header modal-header' closeButton>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={12}>
                                <div className='font-medium font-size4 color-text'>Remove Alert</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>

                {/* Bhagyashri P [23-11-2023] : BT-107432 Set Alerts - class changes start */}
                <BzModalBody className='bdr-btm modal-body'>
                    <Container fluid className='p-0'>
                        <Row className='g-0 mb-3'>
                            <Col md={12}>
                                <div className='font-regular font-size5 color-text text-wrap'>Are you sure you want to remove the following alert(s)?</div>
                            </Col>
                        </Row>
                        <Row className='g-0'>
                            <Col>
                                <div className='remove-alert-block'>
                                    {arrSelectedDeleteAlert?.length && arrSelectedDeleteAlert?.map((item, i) => {
                                        return (
                                            <Row className='g-0 mb-3'>
                                                <Col className='d-flex align-items-center' key={i}>
                                                    <div className='font-medium font-size4 color-text text-uppercase me-2'>{item?.symbol}</div>
                                                    <div className='chips-wrap'>
                                                        <BzChip className='exchange-chip me-2'>{item?.exchange}</BzChip>
                                                    </div>
                                                    <div className='font-regular font-size4 color-subtext'><AlertNameDetails alertData={item} /></div>
                                                </Col>
                                            </Row>
                                        );
                                    })}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    {/* Bhagyashri P [23-11-2023] : BT-107432 Set Alerts - class changes end */}

                </BzModalBody>
                <BzModalFooter className='p-2 modal-footer'>
                    <Container fluid className='p-0'>
                        <Row className='g-0 justify-content-end align-items-center'>
                            <Col md='auto'>
                                <BzButton className='btn btn-md btn-outline me-3' onClick={handleHide}>CLOSE</BzButton>
                            </Col>
                            <Col md='auto'>
                                <BzButton className='btn btn-md btn-primary' onClick={handleRemoveAlert}>REMOVE ALERT</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
        </>
    );
};

export default memo(DeleteAlertConfirmModal);
//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - End